<template> 
    <div v-if="!loading" class="card hashtags">
        <div class="card-header">
            <h3 class="card-title py-1 my-0">Hashtags</h3>
            <div class="card-tools">
                <button type="button" class="btn btn-tool" data-card-widget="maximize" v-tooltip:bottom="translate('messages.expand_data')" data-toggle="tooltip"><i class="fas fa-expand"></i>
                </button>
            </div>
        </div>
        <div class="card-body" v-if="cloud.words.length">
            <h5 class="text-center mb-3">{{translate('messages.explore_hashtags')}}</h5>
            <div class="row align-items-center">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5">
                    <div v-if="current.tag" v-show="false">
                        <div class="mb-3"><span class="h2 mr-1"><strong>{{current.tag}}</strong></span> <span class="h5">{{translate('messages.total')}}: {{current.total}}</span></div>
                        <div v-for="(network, index) in current.networks" :key="'network-'+index" class="mb-3">
                            <div class="mb-1" :class="index+'-brand'">
                                <span class="h4 mr-2"><i :class="index | icon_class"></i> {{index}}</span> <a :href="network.url" target="_BLANK" v-tooltip:bottom="translate('messages.explore_on_network')" data-toggle="tooltip"><i class="fas fa-external-link-alt"></i></a>
                            </div>
                            <div class="progress" style="height: 2em">
                                <div class="progress-bar" :class="index+'-brand-bg'" role="progressbar" :style="'width: '+network.percent+'%'">
                                    <span>{{network.total}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="current.tag" class="text-center">
                        <div class="mb-3"><span class="h2 mr-1"><strong>{{current.tag}}</strong></span></div>
                        <div style="max-width: 250px; margin: 0 auto;">
                            <doughnut :chartData="chart_data" :options="chart_options"/>
                        </div>
                        <span v-for="(network, index) in current.networks" :key="'network-'+index" class="m-2 d-inline-block">
                            <a class="btn" :class="'btn-'+index" :href="network.url" target="_BLANK" v-tooltip:bottom="translate('messages.explore_on')+' '+$options.filters.capitalize(index)" data-toggle="tooltip"><i :class="index | icon_class" class="fa-lg"></i></a><br>{{index | capitalize}}
                        </span>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-7">
                    <vue-word-cloud :words="cloud.words" :style="cloud.style" :spacing="cloud.spacing">
                        <template slot-scope="{text, weight, word}">
                            <div role="button" @click="renderChart(text)" :style="'opacity: '+heatmap_opacity['w_'+weight]" class="tag-cloud-word" :class="$root.app_config.dark_mode ? 'white' : ''">
                                {{ text }}
                            </div>
                        </template>
                    </vue-word-cloud>
                </div>
            </div>
        </div>
        <div v-else class="card-body text-center">
            <small>-{{translate('messages.no_data')}}-</small>
        </div>
    </div>
</template>
 
<script>
import Doughnut from '../charts/DoughnutChart.js'
export default {
    props: ['tags'],
    components: {
      Doughnut
    },
    data () {
        return {
            cloud : {
                words : [],
                style : "width: 100%; height: 300px;",
                spacing : 1.5,
            },
            heatmap_opacity : {},
            current : {
                tag : '',
                networks : {},
                total : 0
            },
            loading : true,
            chart_data : null,
            chart_options : null
        }
    },
    methods: {
        buildCloud(){
            let words = [];
            Object.entries(this.tags).forEach(entry => {
                const [tag, data] = entry;
                words.push([tag, data.total]);
            });
            if(!words.length){
                this.loading = false;
                return;
            };
            let sorted_words = words.sort(function(a,b){
                return (parseInt(b[1]) - parseInt(a[1]));
            }).slice(0,15);
            
            let heatmap_opacity = {};
            let total = 0;
            let max = sorted_words[0][1];
            let min = sorted_words[sorted_words.length - 1][1];
            sorted_words.forEach(word => {
                total = total + word[1];
            });
            sorted_words.forEach(word => {
                let opacity = (word[1]/(max-min)) > 0.7 ? 0.7 : (word[1]/(max-min)) > 0.25 ? (word[1]/(max-min)) : 0.25;
                heatmap_opacity['w_'+word[1]] = opacity;
                total = total + word[1];
            });
            this.heatmap_opacity = heatmap_opacity;
            this.cloud.words = sorted_words;
            this.loading = false;
            this.renderChart(sorted_words[0][0]);
        },
        renderChart(word){
            this.current.tag = word;
            this.current.networks = this.tags[word].networks;
            var labels = [];
            var backgrounds = [];
            var data = [];
            var urls = [];
            Object.entries(this.tags[word].networks).forEach(entry => {
                const [network, network_data] = entry;
                labels.push(this.$options.filters.capitalize(network));
                urls.push(network_data.url);
                backgrounds.push(this.$options.filters.network_color(network, 0.8));
                data.push(network_data.total);
            });

            this.chart_data = {
                labels: labels,
                datasets: [{
                    label: word,
                    borderColor: this.$root.app_config.dark_mode ? '#343a40' : 'rgba(255, 255, 255, 1)',
                    data: data,
                    backgroundColor: backgrounds,
                    hoverOffset: 4,
                    urls : urls
                }]
            };
            
            this.chart_options = {
                responsive: true,
                legend: {
                    display: false,
                    labels: {
                        fontColor: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.8)' : 'rgba(0, 0, 0, 0.8)',
                    }
                },
                elements:{
                    center:{
                        show_total: true,
                        color: this.$root.app_config.dark_mode ? 'rgba(255, 255, 255, 0.8)' : 'rgba(0, 0, 0, 0.8)'
                    }
                }
            }
        }
        
    },
    mounted() {
        this.$root.$on('buildTagCloud', () => {
            this.buildCloud();
        });
       this.buildCloud();
    },
    created() {
       
    },
    beforeDestroy() {
        
    },
    watch: {
        tags(){
            this.buildCloud();
        }
    }
}
</script>